import api from "./apiSlice";

const customersApi = api.injectEndpoints({
  endpoints(build) {
    return {
      getCustomer: build.query({
        query() {
          return "/extras/api/v2/customers/me";
        },
        providesTags: ["Customer"],
        transformResponse: (response) => ({
          id: response.id,
          userId: response.user_id,
          email: response.email,
          firstName: response.first_name,
          lastName: response.last_name,
          companyName: response.company_name,
          phoneNumber: response.phone_number,
          createdAt: response.created_at,
          timezone: response.timezone,
          updatedAt: response.updated_at,
          avatarUrl: response.avatar_url,
          addressStreet: response.address_street,
          addressCity: response.address_city,
          addressState: response.address_state,
          addressCountry: response.address_country,
          addressZipCode: response.address_zip,
          name: response.first_name && response.last_name ? `${response.first_name} ${response.last_name}` : response.first_name || response.last_name || "",
        }),
      }),
      requestDataExport: build.mutation({
        query() {
          return {
            url: "/extras/api/v1/customers/download-data",
            method: "POST",
          };
        },
        invalidatesTags: ["DataExport"],
      }),
      retrieveExportedData: build.query({
        query() {
          return "/extras/api/v1/customers/download-data";
        },
        providesTags: ["DataExport"],
      }),
    };
  },
});

export const { useRequestDataExportMutation, useRetrieveExportedDataQuery, useGetCustomerQuery } = customersApi;
